<template>
  <div class="community mb-4" v-if="isDisplay">
    <div class="community_header mb-2">
      {{ $t('dashboard.community.header_title') }}
    </div>
    <div class="community_content">
      <img src="@/core/assets/new-dashboard/gp-community.png" class="community_thumbnail" alt="">
      <div class="community_title typo-title2 text-lightmode">{{ $t('dashboard.community.desc') }}</div>
      <a 
        :href="communityUrl"
        target="_blank"
        class="community_action btn mx-2 mb-2 btn-light2"
        @click="onViewCommunity"
      >
        {{ $t('dashboard.community.action.title') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Community",
  data() {
    return {
      isDisplay: false,  
      communityUrl: 'https://www.facebook.com/groups/gempages.community',
    }
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo",
    }),
  },
  mounted() {
    this.isDisplay = !this.shopInfo.viewCommunity || this.shopInfo.viewCommunity !== "1";
  },
  methods: {
    ...mapActions("dashboard", {
      setViewCommunityMeta: "setViewCommunityMeta",
    }),
    onViewCommunity() {
      this.setViewCommunityMeta();
    }
  },
};
</script>

<style lang="scss" scoped>
  .community {
    &_header {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: #212121;
    }
    &_content {
      border: 1px solid #D6D6D6;
      border-radius: 3px;
    }
    &_thumbnail {
      width: 100%;
      height: 100%;
      border-radius: 3px 3px 0 0;
      display: block;
    }
    &_action {
      line-height: 21px !important;
      padding: 9.5px
    }
  }
</style>
